import React, { FC } from "react"
import CardTable from "../../../ui/table/CardTable"

type TrackIsrcCodesProps = {
  userAdminPermissions?: string
}

const TrackIsrcCodes: FC<TrackIsrcCodesProps> = (props) => {
  return (
    <div className="flex justify-center">
      <CardTable
        userAdminPermissions={props.userAdminPermissions}
        title={`Track ISRC Codes`}
        urlBase="isrc_codes"
        dataName="ISRC"
        dataKey="isrc"
        itemName="ISRC Code"
        iconPath="/lyrics.svg"
      />
    </div>
  )
}

export default TrackIsrcCodes
